export interface Job {
  chrTrackingNumber: string;
  matchedField: string;
  matchedValue: string;
  estimatedArrival: string;
  mode: ShippingMode;
  modeCode: string;
  status: Status;
  riskLevel: RiskLevel;
  carrierName: string;
  estimatedFirstDelivery: string;
  estimatedDestinationDelivery: string;
  currentLocation: CurrentLocation;
  currentMilestone: CurrentMilestone;
  cargoSummary: CargoSummary;
  stops: Stop[];
  trackingEvents: TrackingEvent[];
  containers: Container[];
  destinationDate?: string;
  customsStatus?: string;
  dispositionDate?: string;
  cargoReady?: string;
  jobType?: JobType;
  referenceNumbers?: ReferenceNumber[];
  items: Item[];
  division?: string;
}

export enum Status {
  None = '',
  Ordered = 'Ordered',
  Booked = 'Booked',
  InTransit = 'In Transit',
  Delivered = 'Delivered',
}

export enum RiskLevel {
  Unassigned = 'Unassigned',
  Early = 'Early',
  OnTime = 'On Time',
  Late = 'Late',
  AtRisk = 'At Risk',
}

export enum ShippingMode {
  Air = 'Air',
  Bulk = 'Bulk',
  Consolidated = 'Consolidated',
  Flatbed = 'Flatbed',
  Intermodal = 'Intermodal',
  LTL = 'LTL',
  Ocean = 'Ocean',
  SmallParcel = 'Small Parcel',
  TMCOcean = 'TMCOcean',
  Truckload = 'Truckload',
  Tautliner = 'Tautliner',
}

export enum StopType {
  Drop = 'Drop',
  Pick = 'Pick',
  OriginPort = 'OriginPort',
  OriginAirport = 'OriginAirport',
  DestinationPort = 'DestinationPort',
  DestinationAirport = 'DestinationAirport',
}

export enum StopStatus {
  None = '',
  InTransit = 'In Transit',
  Current = 'Current',
  Completed = 'Completed',
}

export enum JobType {
  Unknown = 0,
  Shipment = 1, // 1
  Order = 2, // 2
}

export interface CurrentLocation {
  lastUpdateDateTime?: string;
  location?: Location;
}
export interface CurrentMilestone {
  location?: Location;
}

export interface Stop {
  requested?: string;
  scheduledOpenDateTime?: string;
  scheduledCloseDateTime?: string;
  eta?: string;
  etaSource?: string;
  arrived?: string;
  departed?: string;
  stopType: StopType;
  stopStatus: StopStatus;
  sequenceNumber: number;
  numberOfItems?: number;
  quantity?: number;
  totalWeight?: Measurement;
  pallets: number;
  location: Location;
}

export interface TrackingEvent {
  containerId: number;
  eventDate: string;
  containerNumber?: string;
  city: string;
  countryCode: string;
  stateCode: string;
  packageNumber?: string;
  notes: string;
  updatedDateTime: string;
}

export interface Container {
  containerNumber: string;
  containerType: string;
  estimatedDelivery: string;
  requestedDelivery?: string;
  delivered?: string;
  status: Status;
  riskLevel: RiskLevel;
  sealNumber: string;
  priority?: boolean;
  numberOfCommodities: number;
  totalWeight?: Measurement;
  volume?: Measurement;
  outerPackQuantity?: number;
  uom: string;
  eventDateTime: string;
  location: Location;
}

export interface CargoSummary {
  flight: string;
  flightNumber: string;
  customes: string;
  departed: string;
  arrived: string;
  outerPackQuantity?: number;
  chargeableWeight?: Measurement;
  actualWeight?: Measurement;
  uom: string;
}

export interface Location {
  name?: string;
  city: string;
  state: string;
  zipcode?: string;
  country: string;
  latitude?: number;
  longitude?: number;
}

export interface Measurement {
  metric: number;
  standard: number;
}

export interface ReferenceNumber {
  type: string;
  value: string;
}

export interface Item {
  sku?: string;
  packaging: Packaging;
  unitQuantity: number;
  totalPallets: number;
  totalWeight: ItemTotalWeight;
}

export interface ItemTotalWeight {
  unitRDN: number;
  value: number;
}

export interface Packaging {
  value: string;
}